(function () {
  'use strict';
  const DAY = 86400000;
  const RATES = [5, 7, 10];
  function parseTime(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d{1,3})?)?(?:Z|[+-](?:[01]\d|2[0-3]):[0-5]\d)$/.test(value)) return NaN;
    const date = value.slice(0, 10);
    const calendar = Date.parse(date + 'T00:00:00Z');
    if (!Number.isFinite(calendar) || new Date(calendar).toISOString().slice(0, 10) !== date) return NaN;
    return Date.parse(value);
  }
  const validId = value => /^\d+$/.test(String(value)) && Number(value) > 0 && Number.isSafeInteger(Number(value));
  function validDay(day) {
    if (!day || !/^\d{4}-\d{2}-\d{2}$/.test(day.date) || !Array.isArray(day.products) || !day.products.length || day.products.length > 8) return false;
    const start = parseTime(day.startsAt);
    const end = parseTime(day.endsAt);
    const midnight = Date.parse(day.date + 'T00:00:00+05:30');
    if (!Number.isFinite(start) || !Number.isFinite(end) || !Number.isFinite(midnight)) return false;
    if (new Date(midnight + 19800000).toISOString() !== day.date + 'T00:00:00.000Z') return false;
    if (start < midnight || start >= end || end !== midnight + DAY) return false;
    const seen = new Set();
    return day.products.every(product => {
      if (!product || !validId(product.variantId) || !product.handle || !RATES.includes(Number(product.percentage)) || seen.has(String(product.variantId))) return false;
      seen.add(String(product.variantId));
      return true;
    });
  }
  function activeDay(schedule, now) {
    if (!schedule || schedule.enabled !== true || schedule.verified !== true || !Array.isArray(schedule.days) || !Number.isFinite(now)) return null;
    const matching = schedule.days.filter(day => validDay(day) && now >= parseTime(day.startsAt) && now < parseTime(day.endsAt));
    return matching.length === 1 ? matching[0] : null;
  }
  function offerState(schedule, variantId, now, card) {
    const day = activeDay(schedule, now);
    if (!day) return { active: false, percentage: 0, kind: 'none', endsAt: null };
    const product = day.products.find(product => String(product.variantId) === String(variantId));
    if (!product) return { active: false, percentage: 0, kind: 'none', endsAt: null };
    return { active: true, percentage: Number(product.percentage), kind: 'daily', endsAt: parseTime(day.endsAt) };
  }
  function discountedPrice(price, percentage) {
    return Number.isSafeInteger(price) && price >= 0 && [0, 5, 7, 10].includes(percentage) ? Math.round(price * (100 - percentage) / 100) : null;
  }
  function mrpSavings(mrp, selling, final) {
    if (![mrp, selling, final].every(Number.isSafeInteger) || mrp <= 0 || selling < 0 || final < 0 || mrp < selling || mrp <= final) return null;
    return { percentage: Math.floor((mrp - final) * 100 / mrp), saving: mrp - final };
  }
  function countdown(end, now) {
    const total = Math.max(0, Math.ceil((end - now) / 1000));
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    return (hours ? String(hours).padStart(2, '0') + ':' : '') + String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }
  const state = { parseTime, validDay, activeDay, offerState, discountedPrice, mrpSavings, countdown };
  if (typeof window !== 'undefined') window.WavexDealState = state;
  if (typeof module !== 'undefined' && module.exports) module.exports = state;
  if (typeof document === 'undefined') return;

  function initialize(root) {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const preview = root.dataset.preview === 'true';
    let schedule;
    let strings;
    try {
      schedule = JSON.parse(root.querySelector('[data-deal-schedule]').textContent);
      strings = JSON.parse(root.querySelector('[data-deal-strings]').textContent);
    } catch (_) { return; }
    if (preview) return;
    const formatMoney = new Intl.NumberFormat('en-IN', { style: 'currency', currency: root.dataset.currency || 'INR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const formatDate = new Intl.DateTimeFormat('en-IN', { timeZone: 'Asia/Kolkata', day: 'numeric', month: 'short' });
    const panels = Array.from(root.querySelectorAll('[data-day-panel]'));
    const cards = Array.from(root.querySelectorAll('[data-deal-card]'));
    const empty = root.querySelector('[data-empty]');
    const dailyClock = root.querySelector('[data-daily-clock]');
    const money = cents => formatMoney.format(cents / 100);
    const details = card => ({ pack: card.dataset.pack, sku: card.dataset.sku, inventoryPolicy: card.dataset.inventoryPolicy });
    const text = (element, value) => { if (element && element.textContent !== value) element.textContent = value; };
    const status = (card, message) => text(card.querySelector('[data-cart-status]'), message);
    const getOffer = (card, now) => offerState(schedule, card.dataset.variantId, now, details(card));
    function renderCard(card, now) {
      const offer = getOffer(card, now);
      const price = Number(card.dataset.price);
      const discounted = discountedPrice(price, offer.percentage);
      const usable = offer.active && discounted !== null;
      const savings = usable ? mrpSavings(Number(card.dataset.mrp), price, discounted) : null;
      const available = card.dataset.available === 'true';
      const form = card.querySelector('[data-deal-form]');
      const button = form && form.querySelector('button');
      const view = card.querySelector('[data-view-product]');
      card.dataset.offer = usable ? offer.kind : 'none';
      card.dataset.shownPercentage = usable ? String(offer.percentage) : '0';
      text(card.querySelector('[data-deal-price]'), money(usable ? discounted : price));
      text(card.querySelector('[data-price-label]'), usable ? strings.dealPrice : strings.currentPrice);
      card.querySelector('[data-original-price]').hidden = !savings;
      const badge = card.querySelector('[data-offer-badge]');
      badge.hidden = !usable;
      if (usable) {
        const prefix = strings.dailyBadge;
        badge.replaceChildren(document.createTextNode(prefix + (savings ? ' ' : '')));
        if (savings) { const strong = document.createElement('b'); strong.textContent = savings.percentage + '% ' + strings.off; badge.appendChild(strong); }
      }

      const saving = card.querySelector('[data-saving]');
      saving.hidden = !savings;
      if (savings) text(saving, strings.saving + ' ' + money(savings.saving));
      if (form) form.hidden = !usable;
      view.hidden = usable && available;
      if (button) {
        button.disabled = !usable || !available || card.dataset.pending === 'true';
        if (card.dataset.pending !== 'true') text(card.querySelector('[data-add-label]'), available ? strings.add : strings.soldOut);
      }
    }
    function render() {
      const now = Date.now();
      const day = activeDay(schedule, now);
      const panel = day && panels.find(panel => panel.dataset.dayPanel === day.date);
      const hasCards = panel && panel.querySelector('[data-deal-card]');
      panels.forEach(item => { item.hidden = item !== panel; });
      empty.hidden = Boolean(hasCards);
      dailyClock.hidden = !hasCards;
      cards.forEach(card => renderCard(card, now));
      if (hasCards) {
        text(root.querySelector('[data-day-date]'), formatDate.format(parseTime(day.startsAt)) + ' · IST');
        text(root.querySelector('[data-day-countdown]'), countdown(parseTime(day.endsAt), now));
      }
    }
    async function addToCart(event) {
      const form = event.target.closest('[data-deal-form]');
      if (!form || !root.contains(form)) return;
      event.preventDefault();
      const card = form.closest('[data-deal-card]');
      if (card.dataset.pending === 'true') return;
      const previouslyShown = Number(card.dataset.shownPercentage);
      const offer = getOffer(card, Date.now());
      render();
      if (!offer.active || card.dataset.available !== 'true') { status(card, strings.offerExpired); return; }
      if (previouslyShown !== offer.percentage) { status(card, strings.offerChanged); return; }
      card.dataset.pending = 'true';
      const button = form.querySelector('button');
      button.disabled = true;
      text(card.querySelector('[data-add-label]'), strings.adding);
      status(card, '');
      try {
        const response = await fetch(root.dataset.cartAddUrl.replace(/\.js$/, '') + '.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(card.dataset.variantId), quantity: 1 }] })
        });
        let result;
        try { result = await response.json(); } catch (_) { throw new Error('uncertain'); }
        if (!response.ok) {
          status(card, typeof result.description === 'string' ? result.description : strings.addError);
          if (response.status === 422) card.dataset.available = 'false';
        } else {
          status(card, strings.added);
          card.querySelector('[data-view-cart]').hidden = false;
        }
      } catch (_) {
        status(card, strings.addUncertain);
        card.querySelector('[data-view-cart]').hidden = false;
      } finally {
        card.dataset.pending = 'false';
        render();
      }
    }
    root.addEventListener('submit', addToCart);
    root.querySelector('[data-refresh]').addEventListener('click', () => window.location.reload());
    const visibility = () => { if (!document.hidden) render(); };
    document.addEventListener('visibilitychange', visibility);
    const timer = window.setInterval(() => { if (!document.hidden) render(); }, 1000);
    root._wxDealsCleanup = () => { window.clearInterval(timer); document.removeEventListener('visibilitychange', visibility); root.removeEventListener('submit', addToCart); };
    render();
  }
  function boot(container) {
    if (container.matches && container.matches('[data-wx-deals]')) initialize(container);
    container.querySelectorAll('[data-wx-deals]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  else boot(document);
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-wx-deals]').forEach(root => { if (root._wxDealsCleanup) root._wxDealsCleanup(); }));
})();
